var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBracketsAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2ZM6.25 6.25C5.83579 6.25 5.5 6.58579 5.5 7V9.43934L3.46967 11.4697C3.17678 11.7626 3.17678 12.2374 3.46967 12.5303L5.5 14.5607V17C5.5 17.4142 5.83579 17.75 6.25 17.75H9.25C9.66421 17.75 10 17.4142 10 17C10 16.5858 9.66421 16.25 9.25 16.25H7V14.25C7 14.0511 6.92098 13.8603 6.78033 13.7197L5.06066 12L6.78033 10.2803C6.92098 10.1397 7 9.94891 7 9.75V7.75H9.25C9.66421 7.75 10 7.41421 10 7C10 6.58579 9.66421 6.25 9.25 6.25H6.25ZM14.75 6.25C14.3358 6.25 14 6.58579 14 7C14 7.41421 14.3358 7.75 14.75 7.75H17V9.75C17 9.94891 17.079 10.1397 17.2197 10.2803L18.9393 12L17.2197 13.7197C17.079 13.8603 17 14.0511 17 14.25V16.25H14.75C14.3358 16.25 14 16.5858 14 17C14 17.4142 14.3358 17.75 14.75 17.75H17.75C18.1642 17.75 18.5 17.4142 18.5 17V14.5607L20.5303 12.5303C20.8232 12.2374 20.8232 11.7626 20.5303 11.4697L18.5 9.43934V7C18.5 6.58579 18.1642 6.25 17.75 6.25H14.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketsAlt2);
export default __webpack_public_path__ + "static/media/brackets-alt-2.71321612e3c924f66cfcd361c6e5f485.svg";
export { ForwardRef as ReactComponent };